export const AESSecretKey = "0cd445b6db14e699LNweZatSP38PXT9g";
